<template>
  <fragment>
    <div class="main_page">
      <app-navbar></app-navbar>
      <div class="page">
        <div>
          <div class="page-title">
            <h1>Purchase Success</h1>
          </div>

          <div class="page-content">
            <div class="row d-flex justify-content-end">
              <menu class="d-flex align-items-center justify-content-end m-0">
                <router-link :to="{ name: 'project-info' }" title="Back to Project">Back to Project</router-link>
              </menu>
            </div>

            <p>
              Thank you for your purchase - you now have access to your project.
            </p>

          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import AppNavBar from "@/components/app-navbar.vue";

export default {
  components: {
    "app-navbar": AppNavBar
  },
  mounted() {
    this.isPageLoading = false;
  }
};
</script>
